<template>
  <div>
    <div class="d-flex index-banner banner-div row">
      <div class="col-sm-1  col-md-1"></div>
      <div class="bannerDiv col-sm-4  col-md-4">
        <br />
        <h3>麻花超级签名</h3>
        <br />
        <h5>我们提供专业的手机应用内测服务，全国CDN高速分发</h5>
        <br />
        <h5>我们面向个人开发者、初创技术团队、中小企业提供苹果应用超级签名服务</h5>
        <br />
        <h5>我们通过共有个人开发者账号和私有个人开发者账号分别提供超级签名和UDID代签服务</h5>
      </div>
      <div class="col-sm-6 col-md-6">
        <img class="banner-img" src="../assets/img/index_banner.png" />
      </div>
      <div class="col-sm-1 col-md-1"></div>
    </div>
    <div class="show-section">
      <div class="container">
        <div class="row show-row">
          <div class="col-6 col-lg-3">
            <!-- <a target="_blank" class="show-box" :href="_Global.QQ_TUIGUANG"> -->
              <router-link class="show-box" :to="{name:'SuperSign'}">
              <img src="../assets/images/menu4.png" alt="" />
              <h3>超级签名</h3>
              <p>24小时在线自动超级签名，稳定不掉，可签推送；支持应用二合一</p>
              </router-link>
            <!-- </a> -->
          </div>
          <div class="col-6 col-lg-3">
            <a class="show-box">
              <img src="../assets/images/menu1.png" alt="" />
              <h3>无需信任</h3>
              <p>下载即用，方便快捷，省去设置信任烦恼，客户上手更容易便捷。</p>
            </a>
          </div>
          <div class="col-6 col-lg-3">
            <router-link class="show-box" to="/apps">
              <img src="../assets/images/menu2.png" alt="" />
              <h3>一键分发</h3>
              <p>一键上传苹果安卓应用文件，合并二维码下载，微信内可直接扫码安装，全球节点高速下载，快速稳定</p>
            </router-link>
          </div>
          <div class="col-6 col-lg-3">
            <a class="show-box">
              <img src="../assets/images/menu3.png" alt="" />
              <h3>服务稳定</h3>
              <p>采取更优策略提高稳定性，致力于为您提供最优质的平台服务。</p>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- As seen on -->
    <!-- <div class="footer navbar-dark fixed-bottom">
      <div style="font-size: 16px" class="foot-info">声明：严禁所有用户上传违法内容，一经发现，封号处理并上报给国家法律部门。</div>
      <div class="copyright">Copyright © 2016-2018 ©武汉博太世纪科技有限公司 鄂ICP备17025151号-5 </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  mounted() {
    //   alert(window.navigator.userAgent)
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .banner-img {
  }
}

@media only screen and (min-width: 1200px) {
  .banner-img {
    margin-top: 5em;
    width: 40em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue